module.exports = __webpack_public_path__ + "static/giant-5513909125d767212fb5840c872ea156.png";